import React, { useState } from "react";

type CheckboxProps = React.PropsWithChildren & {
    label?: string | React.JSX.Element;
    id: string;
    name: string;
    className?: string;
    textStyle?: string;
    defaultState?: boolean;
    isInline?: boolean;
    onClick?: () => void;
    width?: string;
    height?: string;
    checkStyle?: string;
};

const Checkbox: React.FC<CheckboxProps> = ({
    label = "",
    id,
    name,
    onClick,
    defaultState = false,
    isInline = false,
    children,
    textStyle,
    className = "",
    width = "24",
    height = "24",
    checkStyle,
}) => {
    const [isChecked, setIsChecked] = useState(defaultState);

    const handleChange = () => {
        if (onClick) onClick();
        setIsChecked((prev) => !prev);
    };

    return (
        <label className={`${className} flex items-center justify-start w-fit cursor-pointer`}>
            <div className="relative inline-flex wrap mr-2">
                <input
                    id={id}
                    type="checkbox"
                    name={name}
                    className={`absolute opacity-0 cursor-pointer w-[${width}px] h-[${height}px]`}
                    checked={isChecked}
                    onChange={handleChange}
                />
                <svg
                    width={width}
                    height={height}
                    viewBox="0 0 24 24"
                    fill="none"
                    xmlns="http://www.w3.org/2000/svg"
                    className={`${checkStyle} transition-all duration-300 ease-in-out`}
                >
                    <rect
                        x="2"
                        y="2"
                        width="20"
                        height="20"
                        rx="4"
                        fill={isChecked ? "#2376E5" : "transparent"}
                        stroke={isChecked ? "#2376E5" : "#ccc"}
                        strokeWidth="1"
                        className="transition-all duration-300 ease-in-out"
                    />
                    {isChecked && (
                        <path
                            d="M7 12.5L10 15.5L17 8.5"
                            stroke="white"
                            strokeWidth="2"
                            strokeLinecap="round"
                            strokeLinejoin="round"
                            className="transition-opacity duration-300 ease-in-out opacity-100"
                        />
                    )}
                </svg>
            </div>
            {isInline && (
                <>{children || label}</>
            ) || (
                    <div className={`${textStyle ? textStyle : 'text-base-16'} select-none ml-2`}>{children || label}</div>
                )}
        </label>
    );
};

export default Checkbox;
